import styled, { keyframes, css } from 'styled-components';
import { injectSpacing } from '../../api/spacing/injectSpacing';
import { injectTypography } from '../../utils/injectTypography';
/** Circumfence in pixels based on --size of the circle */
const circumfence = `calc(${Math.PI} * (var(--size) - var(--stroke-width)))`;
/** Convert degrees of an arc to dash lengths in pixels based on --size of the circle */
const dashLengthFromAngle = (deg) => `calc(${deg} / 360 * ${circumfence})`;
/** Layer one of the continuous spinning animation - pure rotation */
const continuousSpinningKeyframes = keyframes `
  from {
    transform: rotate(-90deg)
  }
  to {
    transform: rotate(270deg);
  }
`;
/** Layer two of the continuous spinning animation - SVG strokes */
const continuousCircularLoadingKeyframes = keyframes `
  0% {
      stroke-dasharray: ${[0, 360].map(dashLengthFromAngle).join(',')};
      stroke-dashoffset: ${dashLengthFromAngle(0)};

      animation-timing-function: ease-in;
  }
  20% {
      stroke-dasharray: ${[200, 360].map(dashLengthFromAngle).join(',')};
      stroke-dashoffset: ${dashLengthFromAngle(-40)};
  }
  100% {
      stroke-dasharray: ${[200, 360].map(dashLengthFromAngle).join(',')};
      stroke-dashoffset: ${dashLengthFromAngle(-360)};
  }
`;
const continuousCircularLoadingAnimation = css `
  animation: ${continuousCircularLoadingKeyframes} 1.5s
    cubic-bezier(0.3, 0.95, 0.65, 0.9) infinite both;
`;
// Handle determinate percentage values (as opposed to the continual spinner)
const circularPercentValue = css `
  stroke-dasharray: calc(var(--progress) * ${circumfence}),
    ${dashLengthFromAngle(360)};

  transform: rotate(-90deg);

  transition: stroke-dasharray 0.1s ${(props) => props.theme.easing};
`;
/** Continuous horizontal bar animation */
const continuousHorizontalLoadingKeyframes = keyframes `
  0% {
    transform: translateX(0%) scaleX(0.0);
  }
  50% {
    transform: translateX(20%) scaleX(0.5);

    animation-timing-function: cubic-bezier(0,0,0,1);
  }
  100% {
    transform: translateX(100%) scaleX(0.5);
  }
`;
const continuousHorizontalLoadingAnimation = css `
  animation: ${continuousHorizontalLoadingKeyframes} 1s
    cubic-bezier(0.85, 0, 1, 1) infinite;
`;
/** Handle determinate percentage values (as opposed to the continual spinner) */
const horizontalPercentValue = css `
  transform: scaleX(var(--progress));

  transition: transform ease-in-out 0.1s;
`;
export const circularLoaderSizes = {
    continuous: {
        small: {
            diameter: 24,
            stroke: 2,
        },
        large: {
            diameter: 48,
            stroke: 3,
        },
    },
    determinate: {
        small: {
            diameter: 48,
            stroke: 3,
        },
        large: {
            diameter: 96,
            stroke: 4,
        },
    },
};
export const StyledContainer = styled.div `
  --size: ${(props) => circularLoaderSizes[props.progressType][props.size].diameter}px;
  --stroke-width: ${(props) => circularLoaderSizes[props.progressType][props.size].stroke}px;
  --train-color: ${(props) => props.monochrome
    ? props.theme.colors.ui.primary
    : props.theme.colors.ui.accent};
  --track-color: ${(props) => props.theme.colors.utility.neutral[10]};
  --progress: ${(props) => props.progress};

  position: relative;

  display: inline-block;

  width: ${(props) => props.variant === 'linear' && ' 100%'};

  ${injectSpacing('margin')}
`;
// Circular loader styles
export const StyledCircularLoader = styled.svg `
  display: block;
  width: var(--size);
  height: var(--size);

  transform-origin: 50% 50%;

  animation: ${(props) => props.progressType === 'continuous' &&
    css `
      ${continuousSpinningKeyframes} 1.5s cubic-bezier(0.4, 0, 0.3, 1) infinite
    `};
`;
export const StyledCircularTrain = styled.circle `
  transform-origin: 50% 50%;

  fill: none;

  stroke: var(--train-color);
  stroke-width: calc(var(--stroke-width));

  ${(props) => props.progressType === 'continuous'
    ? continuousCircularLoadingAnimation
    : circularPercentValue}
`;
export const StyledCircularTrack = styled.circle `
  fill: none;

  stroke: var(--track-color);
  stroke-width: var(--stroke-width);
`;
export const StyledValue = styled.div `
  position: absolute;
  top: 50%;
  left: 50%;

  max-width: calc(var(--size) - var(--stroke-width) * 2 - 1ch);

  overflow: hidden;

  ${(props) => injectTypography(props, props.size === 'large' ? 'copy1' : 'copy2')}
  color: ${(props) => props.theme.colors.text.secondary};

  text-overflow: ellipsis;

  transform: translate(-50%, -50%);
`;
// Horizontal loader styles
export const StyledProgressBar = styled.div `
  position: relative;

  width: 100%;
  height: 4px;
  overflow: hidden;

  background-color: var(--track-color);
`;
export const StyledProgressBarTrain = styled.div `
  position: absolute;
  top: 0%;

  width: 100%;
  height: 100%;

  background-color: var(--train-color);

  transform-origin: 0% 0%;

  ${(props) => props.progressType === 'continuous'
    ? continuousHorizontalLoadingAnimation
    : horizontalPercentValue}
`;
//# sourceMappingURL=Loader.styles.js.map